module.exports = __webpack_public_path__ + "static/media/item_19_2_comp.584e4d2b.png";